import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["metricSelect", "rulebookSelect"]

  connect() {
    console.log('ClientBandOverrideFormController conectado')
    if (this.hasRulebookSelectTarget && this.hasMetricSelectTarget) {
      console.log('Targets encontrados, inicializando...')
      
      // Atualizar quando o select2 for inicializado
      const $rulebookSelect = $(this.rulebookSelectTarget)
      
      // Atualizar quando um valor for selecionado
      $rulebookSelect.on('select2:select', (e) => {
        console.log('Rulebook selecionado:', e.params.data)
        this.updateMetricOptions()
      })

      // Atualizar quando o valor for limpo
      $rulebookSelect.on('select2:clear', () => {
        console.log('Rulebook limpo')
        this.updateMetricOptions()
      })

      // Atualizar se já houver um valor selecionado
      if ($rulebookSelect.val()) {
        console.log('Valor inicial encontrado')
        this.updateMetricOptions()
      }
    } else {
      console.log('Targets não encontrados:', {
        rulebookSelect: this.hasRulebookSelectTarget,
        metricSelect: this.hasMetricSelectTarget
      })
    }
  }

  updateMetricOptions() {
    const $rulebookSelect = $(this.rulebookSelectTarget)
    const $metricSelect = $(this.metricSelectTarget)
    
    // Obter o valor selecionado
    const rulebookId = $rulebookSelect.val()
    const select2Data = $rulebookSelect.select2('data')[0]
    
    console.log('Atualizando métricas para rulebook:', rulebookId)
    console.log('Select2 data completo:', JSON.stringify(select2Data, null, 2))

    if (!rulebookId) {
      console.log('Nenhum rulebook selecionado')
      $metricSelect.html('<option value="">' + $metricSelect.data('placeholder') + '</option>')
      $metricSelect.trigger('change') // Notificar select2 da mudança
      return
    }

    // Buscar o rulebook e suas métricas disponíveis
    fetch(`/rulebooks/${rulebookId}.json`)
      .then(response => response.json())
      .then(data => {
        console.log('Rulebook data:', data)
        const currentValue = $metricSelect.val()

        // Obter o locale da tag HTML
        const locale = document.documentElement.lang || 'pt-BR'
        
        // Buscar as métricas disponíveis para este rulebook
        fetch(`/${locale}/client_band_overrides/available_metrics?rulebook_id=${rulebookId}`, {
          headers: {
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          }
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }
            return response.json()
          })
          .then(metricsData => {
            console.log('Métricas disponíveis:', metricsData)
            
            let options = '<option value="">' + $metricSelect.data('placeholder') + '</option>'
            metricsData.metrics.forEach(metric => {
              const selected = metric.value === currentValue ? 'selected' : ''
              options += `<option value="${metric.value}" ${selected}>${metric.label}</option>`
            })

            $metricSelect.html(options)
            $metricSelect.trigger('change') // Notificar select2 da mudança
          })
          .catch(error => {
            console.error('Erro ao buscar métricas:', error)
            $metricSelect.html('<option value="">' + $metricSelect.data('placeholder') + '</option>')
            $metricSelect.trigger('change')
            
            // Mostrar mensagem de erro para o usuário
            if (window.Swal) {
              window.Swal.fire({
                title: 'Erro',
                text: 'Não foi possível carregar as métricas disponíveis. Por favor, tente novamente.',
                icon: 'error'
              })
            }
          })
      })
  }
}

